import { render, staticRenderFns } from "./DialogCustomers.vue?vue&type=template&id=08aff1be&scoped=true&"
import script from "./DialogCustomers.vue?vue&type=script&lang=js&"
export * from "./DialogCustomers.vue?vue&type=script&lang=js&"
import style0 from "./DialogCustomers.vue?vue&type=style&index=0&id=08aff1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08aff1be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAutocomplete,VCard,VDialog,VIcon,VRow})
